import { Breadcrumbs } from 'components/bredcrambs';

import styles from './styles.module.css';
import { providers } from 'constants/routes-breadcrumbs';

export const HeaderProvider = ({
  title,
  subTitle,
}: {
  title: string;
  subTitle?: string;
}) => {
  return (
    <div className={styles.container}>
      <Breadcrumbs items={providers} />

      <h1 className={styles.title}>{title}</h1>
      <p className={styles.sub_title}>{subTitle ?? ''}</p>
    </div>
  );
};
